import { useCallback } from 'react';
import { useWizardService, WIZARD_EVENTS } from '@bingads-webui-fluent-component/wizard';

export const useLinkedInAdsManagerRepository = () => {
  const { state, send } = useWizardService();

  const load = () => new Promise((resolve) => {
    send(WIZARD_EVENTS.UPDATE_FlOW_FACTORS, {
      flowFactors: {
        isAdStepActive: false,
      },
    });

    resolve(state.context.wizardData);
  });

  const save = useCallback(() => Promise.resolve(), []);

  return {
    load,
    save,
  };
};
